const Footer = () => {
  return (
    <footer>
      <div>Roy's Codebase</div>
      <div>
        <i className="fa-solid fa-copyright"></i> 2025
      </div>
    </footer>
  );
};

export default Footer;
